<template>
  <span class="soraban-icon">
    <svgicon
      v-if="isOmniIcon"
      :name="name"
      :height="height"
      :width="width"
      :original="true"
    ></svgicon>
    <v-icon v-bind="$attrs" v-else>{{ name }}</v-icon>
  </span>
</template>

<script>
// import '@/compiled-icons';

export default {
  name: 'SorabanIcon',
  props: {
    name: {
      required: true,
      type: String,
    },
    height: {
      required: false,
      type: String || Number,
    },
    width: {
      required: false,
      type: String || Number,
    },
  },
  computed: {
    isOmniIcon() {
      return [
        'access-explorer',
        'blue-assess',
        'blue-edit',
        'blue-filter',
        'compare',
        'downward-trend',
        'grey-trash',
        'hierarchy-highlight',
        'lock',
        'monitored-services',
        'no-issues',
        'policies',
        'policy-library',
        'reports',
        'red-icon-x',
        'reports',
        'service-groups',
        'service-settings',
        'tree-structure',
        'user-management',
        'white-edit',
        'white-filter',
        'alert-triangle',
        'green-checkmark-circle',
        'users-connectedapp',
        'setupchanges-byuser',
        'connectapp-installations',
        'connectedapp-usage',
        'setupchanges-bytype',
        'calendar',
        'download',
      ].includes(this.name.toLowerCase());
    },
  },
};
</script>
<style scoped lang="postcss">
.soraban-icon {
  text-decoration: none;
  & svg {
    width: 1.4em;
    height: 1.4em;
    fill: currentColor;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
